<script setup lang="ts">
defineProps<{
    text: string;
}>();
</script>

<template>
    <p class="privacy-item__text">
        {{ text }}
    </p>
</template>
